module.exports = __webpack_public_path__ + "static/media/2023_composite.7332a3d1.jpg";